module.exports = __webpack_public_path__ + "static/media/managed.2681f000.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectManagement/ContactOption/assets/managed.svg
// module id = 2081
// module chunks = 0